import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4005f2b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-md" }, "User Debug Info", -1))
const _hoisted_2 = { class: "q-mb-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Authentication Status:", -1))
const _hoisted_4 = { class: "q-mb-md" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Current User:", -1))
const _hoisted_6 = { class: "q-mt-sm" }
const _hoisted_7 = { class: "q-mb-md" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "LocalStorage Token:", -1))
const _hoisted_9 = { class: "q-mb-md" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "LocalStorage User:", -1))
const _hoisted_11 = { class: "q-mt-sm" }
const _hoisted_12 = { class: "q-mb-md" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Role Checks:", -1))
const _hoisted_14 = { class: "q-gutter-sm" }

import { ref, computed } from 'vue';
import { userService, UserRole, User } from '@/service/user-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDebugInfo',
  setup(__props) {

const showDebug = ref(false);

const currentUser = computed(() => userService.getCurrentUser());
const isAuthenticated = computed(() => userService.isAuthenticated());
const isAdmin = computed(() => userService.isAdmin());
const isMarketManager = computed(() => userService.isMarketManager());
const isBranchManager = computed(() => userService.isBranchManager());
const hasAdminRole = computed(() => userService.hasRole(UserRole.ADMIN));
const hasAdminOrHigher = computed(() => userService.hasRoleOrHigher(UserRole.ADMIN));

const hasToken = computed(() => !!localStorage.getItem('token'));
const localStorageUser = computed(() => {
  const userStr = localStorage.getItem('user');
  return userStr || 'No user data in localStorage';
});

const setTestAdminUser = () => {
  const testAdminUser: User = {
    id: 1,
    username: 'admin',
    firstName: 'Test',
    lastName: 'Admin',
    email: 'admin@test.com',
    role: UserRole.ADMIN,
    organizationId: 1,
    organizationName: 'Test Organization',
    assignedBranches: [
      { id: 1, name: 'Main Branch', type: 'MAIN', status: 'ACTIVE' }
    ],
    isActive: true
  };

  const testToken = 'test-admin-token-' + Date.now();

  localStorage.setItem('token', testToken);
  localStorage.setItem('user', JSON.stringify(testAdminUser));

  // Force refresh of user service
  userService.getCurrentUser();

  // Reload the page to refresh all computed values
  window.location.reload();
};

const setCurrentUserAsAdmin = () => {
  // Set your actual user as admin based on the database info you provided
  const adminUser: User = {
    id: 4,
    username: 'monoahror',
    firstName: 'Ahrorjon',
    lastName: 'Komilov',
    email: '',
    role: UserRole.ADMIN,
    organizationId: 2,
    organizationName: 'Your Organization',
    assignedBranches: [],
    isActive: true
  };

  // Keep existing token if available
  const existingToken = localStorage.getItem('token') || 'Bearer your-jwt-token';

  localStorage.setItem('user', JSON.stringify(adminUser));
  localStorage.setItem('token', existingToken);

  // Force refresh of user service
  userService.getCurrentUser();

  // Reload the page to refresh all computed values
  window.location.reload();
};

const clearUserData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Reload the page to refresh all computed values
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showDebug.value)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          class: "q-ma-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(isAuthenticated.value ? 'Authenticated' : 'Not Authenticated'), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("pre", _hoisted_6, _toDisplayString(JSON.stringify(currentUser.value, null, 2)), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(hasToken.value ? 'Present' : 'Missing'), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("pre", _hoisted_11, _toDisplayString(localStorageUser.value), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "Is Admin: " + _toDisplayString(isAdmin.value), 1),
                    _createElementVNode("li", null, "Is Market Manager: " + _toDisplayString(isMarketManager.value), 1),
                    _createElementVNode("li", null, "Is Branch Manager: " + _toDisplayString(isBranchManager.value), 1),
                    _createElementVNode("li", null, "Has ADMIN role: " + _toDisplayString(hasAdminRole.value), 1),
                    _createElementVNode("li", null, "Has ADMIN or higher: " + _toDisplayString(hasAdminOrHigher.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_q_btn, {
                    color: "green",
                    label: "Set My User as Admin (monoahror)",
                    onClick: setCurrentUserAsAdmin,
                    size: "sm"
                  }),
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    label: "Set Test Admin User",
                    onClick: setTestAdminUser,
                    size: "sm"
                  }),
                  _createVNode(_component_q_btn, {
                    color: "secondary",
                    label: "Clear User Data",
                    onClick: clearUserData,
                    size: "sm"
                  }),
                  _createVNode(_component_q_btn, {
                    color: "negative",
                    label: "Hide Debug",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showDebug.value = false)),
                    size: "sm"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!showDebug.value)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          fab: "",
          color: "orange",
          icon: "bug_report",
          class: "fixed-bottom-right q-ma-md",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDebug.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _createTextVNode("Show User Debug Info")
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})